module Meevo.Plugins.Register {
    "use strict";

    export class ButtonsSection extends Meevo.Plugins.Register.RegisterSectionBase {
        giftCardSecurityKey: string;
        hasGiftCardSecurityKey: boolean;
        giftCardInitalStage: GiftCardStageEnum;

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext,
            private securityService: Meevo.Components.Common.ISecurityService) {
            super(RegisterSectionTypeEnum.Buttons, registerContext, "buttonSets", Register.RegisterSectionCatTypeEnum.Sale);

            const singleGiftCardKey = Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_SELLGIFTCARDS + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
            const bulkGiftCardKey = Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_SELLBULKGIFTCARDS + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
            let keysToCheck: string[] = [
                singleGiftCardKey,
                bulkGiftCardKey,
            ];

            this.securityService.checkAndCache(keysToCheck).then((response) => {
                let canSellSingle = _(response).findWhere({ key: singleGiftCardKey});
                let canSellBulk = _(response).findWhere({ key: bulkGiftCardKey});

                // default to a key that has grant so that button can be clicked to get the quantity stage
                this.giftCardSecurityKey = Meevo.Components.Common.SecurityKeys.REGISTER;
                this.giftCardInitalStage = GiftCardStageEnum.Quantity;
                if (canSellSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Grant && 
                    canSellBulk.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                    this.giftCardInitalStage = GiftCardStageEnum.Single;
                }
                else if (canSellSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Deny &&
                    canSellBulk.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                    this.giftCardSecurityKey = Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_SELLGIFTCARDS;
                    this.giftCardInitalStage = GiftCardStageEnum.Single;
                }
                else if (canSellSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                    switch (canSellBulk.securityAccess) {
                        case Meevo.Model.SecurityAccessEnum.Grant:
                            this.giftCardInitalStage = GiftCardStageEnum.Bulk;
                            break;
                        case Meevo.Model.SecurityAccessEnum.Deny:
                            this.giftCardSecurityKey = Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_SELLBULKGIFTCARDS;
                            this.giftCardInitalStage = GiftCardStageEnum.Bulk;
                            break;
                        case Meevo.Model.SecurityAccessEnum.Hide:
                            this.giftCardSecurityKey = Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_SELLGIFTCARDS;
                            break;
                    }
                }
                this.hasGiftCardSecurityKey = true;
            });
        }

        selectSectionGiftCards() {
            this.registerContext.giftCardSection.reset(this.giftCardInitalStage);
            this.registerContext.selectSection(RegisterSectionTypeEnum.GiftCard, false, false, true);
        }
    }
}